<template>
  <div id="app" class="relative">
    <!-- <Notice /> -->
    <!-- <TempPopup /> -->
    <div v-if="isLoading" class="spinnerWrapper">
      <!-- <Spinner class="spinner" /> -->
      <Spinner
        :active="isLoading"
        loader="dots"
        color="#007FA2"
        background-color="#000"
        :opacity="0.5"
        :is-full-page="true"
      />
    </div>
    <!-- <LanguageSwitcher /> -->
    <Header
      v-if="
        !(
          $route.path.includes('/qrcode') || $route.path.includes('/payment')
        ) &&
        (isPc ||
          !($route.path.includes('/login') || $route.path.includes('/join')))
      "
      :is-search="this.isSearch"
    />
    <router-view />
    <Footer
      v-if="
        !(
          $route.path.includes('/qrcode') || $route.path.includes('/payment')
        ) &&
        (isPc ||
          !($route.path.includes('/login') || $route.path.includes('/join')))
      "
    />
  </div>
</template>

<script>
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'
// import Notice from '@/components/popup/Notice.vue'
// import TempPopup from '@/components/popup/TempPopup.vue'
// import LanguageSwitcher from '@/components/common/LanguageSwitcher.vue'
// import Spinner from 'vue-loading-spinner/src/components/CubeShadow.vue'

import { showPopup, universityName, isNiaMode } from '@/store/constants'
import {
  AUTH_REFRESH
  // STORE_POPUP
} from '@/store/types'
import { mapGetters } from 'vuex'

import 'vue-loading-overlay/dist/vue-loading.css'
import '@/assets/css/base.css'
import '@/assets/global.scss'

export default {
  components: {
    Header,
    Footer
    // Notice
    // TempPopup
    // LanguageSwitcher,
    // Spinner
  },
  // **********************event
  data() {
    return {
      universityName,
      showPopup,
      isShowEventPopup: true,
      isShowEventPopup2: true,
      isNiaMode,
      isSearch: true,
      checked: false,
      isPc: false,
      isMobile: false
    }
  },
  // beforeCreate() {
  //   document.title = `${universityName} 이앨리스 - 온라인서점`
  // },
  // **********************event

  computed: {
    isLoading() {
      if (this.isAuthLoading || this.getLoading) return true
      return false
    },
    layout() {
      return `${this.$route.meta.layout || 'default'}-layout`
    },
    cookieNm() {
      if (this.universityName) {
        return this.universityName.trim()
      } else {
        return ''
      }
    },
    popupImage() {
      // console.log(this.getPopup?.popup?.url[0])
      return this.getPopup?.popup?.url[0].bannerUrl
    },
    popupUrl() {
      // console.log(this.getPopup?.popup?.url[0])
      return this.getPopup?.popup?.url[0].linkUrl
    },
    popupTitle() {
      // console.log(this.getPopup?.popup?.url[0])
      return this.getPopup?.popup?.url[0].bannerTitle
    },
    ...mapGetters(['getLoading', 'isAuthLoading', 'getPopup'])
  },
  beforeMount() {
    // const cookieNm = this.universityName.trim()
    // **********************event
    let value = document.cookie.match(
      `(^|;) ?evtPopupYn${this.cookieNm}1=([^;]*)(;|$)`
    )
    value ? (this.isShowEventPopup = false) : ''

    let value2 = document.cookie.match(
      `(^|;) ?evtPopupYn${this.cookieNm}2=([^;]*)(;|$)`
    )
    value2 ? (this.isShowEventPopup2 = false) : ''
    // **********************event
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      window.innerWidth - document.documentElement.clientWidth + 'px'
    )
  },
  updated() {
    this.$route.name != 'search'
      ? (this.isSearch = false)
      : (this.isSearch = true)
    // if (this.$route.name != 'search') {
    //   this.isSearch = false
    //   console.log('notchange')
    // }
  },
  async mounted() {
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
    let token = localStorage.getItem('token')

    if (token) {
      try {
        // console.log('a-issue')
        await this.$store.dispatch(AUTH_REFRESH)
      } catch (err) {
        // console.log(err)
        // this.$store.dispatch(AUTH_LOGOUT)
      }
    }
    // await this.$store.dispatch(STORE_POPUP)
    this.$cookies.get('pcMode') === 'isPcModeTrue'
      ? document
          .getElementById('viewport')
          .setAttribute('content', process.env.VUE_APP_VIEWPORT_PCMODE)
      : ''
  },
  methods: {
    checkWindowSize() {
      this.isPc = window.innerWidth > 480
      this.isMobile = window.innerWidth <= 480
    },
    checkCloseEvtPopup() {
      const chKBox = document.getElementById('closeOneDay')
      if (chKBox.checked == true) {
        var todayDate = new Date()
        todayDate.setHours(24)
        document.cookie =
          `evtPopupYn${this.cookieNm}1` +
          '=' +
          escape('N') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
        this.isShowEventPopup = false
      } else {
        this.isShowEventPopup = false
      }
    },
    onCancel() {
      // console.log('User cancelled the loader.')
    },
    closeEvtPopup(no) {
      no === 1
        ? (this.isShowEventPopup = false)
        : (this.isShowEventPopup2 = false)
    },
    closeOneDay(no) {
      var todayDate = new Date()
      todayDate.setHours(24)
      document.cookie =
        `evtPopupYn${this.cookieNm}${no}` +
        '=' +
        escape('N') +
        '; path=/; expires=' +
        todayDate.toGMTString() +
        ';'
      no === 1
        ? (this.isShowEventPopup = false)
        : (this.isShowEventPopup2 = false)
    },
    goEvtPage() {
      // window.ChannelIO('track', '반품')
      // window.open(
      //   'https://docs.google.com/forms/d/e/1FAIpQLSd6ak5REDhqsDP5N-OnUq97PuOkH0eDQfSu9qjncstwFwu8Mg/viewform',
      //   'popupEvt',
      //   'height=' + screen.height + ',width=' + screen.width + 'fullscreen=yes'
      // )
    },
    getCookie(name) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      if (parts.length === 2) return parts.pop().split(';').shift()
      return null
    }
  }
}
</script>

<style lang="scss">
@import '../src/assets/scss/_variables';
#app {
  background: #f0f5fa;
  transition: $ease;
  // FIXES ISSUES WITH BOTTOM SPACING ON AUTH AND OTHER PAGES
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
@media all and (min-width: 1440px) {
  .location .btn_open_snb.active {
    width: 22px;
    margin-right: 29px;
  }

  .aside_snb + .library_st .section {
    max-width: 100%;
  }
  .aside_snb + .library_st .location_wrap {
    max-width: 100%;
    padding-left: 66px;
    padding-right: 66px;
  }
}

.spinnerWrapper {
  z-index: 5555;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  touch-action: none;
  overflow-y: auto;
  background-color: rgba(42, 40, 43, 0.6);
}

.spinner {
  position: absolute;
  top: 50%;
  z-index: 9999;
  margin: auto;
  left: calc(50% - 25px);
  background-color: #007aff !important;
}
</style>
